import React, { useEffect, useMemo, useState } from "react";
import { Box, CircularProgress, IconButton, InputAdornment, TextField, Paper, Chip , Button } from "@mui/material";
import { Link, useNavigate, useParams } from "react-router-dom";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import MyTable from "../../components/Schedule/MyTable";
import ApiService from "../../functions/apiService";
import { useSnackbar } from "notistack";
import EmptyState from "../../components/Error/EmptyState";
import Grid from '@mui/material/Grid';
import { Col, Row } from 'react-bootstrap';
import moment from "moment";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { parse } from 'date-fns';
import SearchIcon from "@mui/icons-material/Search";
import { toast } from "react-toastify";

export default function EmployeeLog() {
  // const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();
  let { empId } = useParams();
  const [member, setMember] = useState([]);
  const [data, setData] = useState();
  const [loading, setLoading] = useState(true);
  const [detailsSearch, setDatailsSearch] = useState("");
  const [overTimeSearch, setOverTimeSearch] = useState("");
  const [summarySearch, setSummarySearch] = useState("");
  const [emptyMessage, setEmptyMessage] = useState();
  const [activeTab, setActiveTab] = useState('memberlog');
  const [year, setYear] = useState(new Date());
  const selectedYear = moment(year).format('YYYY');
  const [year2, setYear2] = useState(new Date());
  const selectedYear2 = moment(year2).format('YYYY');
  const [swapRows, setSwapRows] = useState([]);
  const [swapErrorMessage, setSwapErrorMessage] = useState();
  const [swapBalanceRows, setSwapBalanceRows] = useState([]);

  useEffect(() => {
    if (empId) {
      ApiService.get("/getEmployee/" + empId).then(({ data }) => {
        setMember(data?.data)
      });
    } else {
      setLoading(false);
    }
  }, [])

  useEffect(() => {
    ApiService.get("/getEmployeeLog/" + empId, {}, "getEmployeeLog")
      .then(({ data }) => {
        setData(data);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        if (error?.response.status == 400 && error?.response?.data?.message) {
          setEmptyMessage(error?.response?.data?.message);
        } else {
          toast.error(error?.response?.data?.message)
          // enqueueSnackbar("Error", { variant: "error" });
          navigate("/firehouse/members");
        }
      });
  }, []);
  const columns = [
    { field: "Shift_Date", headerName: "Date", flex: 1, minWidth: 95 },
    { field: "AbsentDesc", headerName: "Type", flex: 1, minWidth: 70 },
    { field: "Overtime_List", headerName: "Shift", flex: 1, minWidth: 65 },
    {
      field: "age",
      headerName: "Hours",
      flex: 1,
      minWidth: 40,
      valueGetter: (params) => params.row.custom?.Hours ?? params.row.shift?.Shift_Hours,
    },
    {
      field: "StatusName",
      headerName: "Status",
      renderCell: (params) => {
        return <Chip style={{ width: "100px", fontSize: '10px' }} label={params.row.StatusName} />;
      },
      flex: 1,
      minWidth: 90,
    },
  ];
  const columnsOverTime = [
    {
      field: "Shift_Date",
      headerName: "Shift Date",
      flex: 1,
      minWidth: 40,
    },
    {
      field: "ResponseName",
      headerName: "Status",
      flex: 1,
      minWidth: 100,
      renderCell: (params) => {
        return (
          <Chip style={{ width: "150px" }} label={params.row.ResponseName} />
        );
      },
    },
    { field: "Shift_Type", headerName: "Shift", flex: 1, minWidth: 100 },
    { field: "Hours", headerName: "Hours", flex: 1, minWidth: 100 },
    {
      field: "totalHours",
      headerName: "Total Hours",
      flex: 1,
      minWidth: 120,
    },
    { field: "fullName", headerName: "User", flex: 1, minWidth: 100 },
    { field: "Log_Time", headerName: "Time Stamp", flex: 1, minWidth: 140 },
  ];
  const columnsSummary = [
    { field: "name", headerName: "Type", flex: 1, minWidth: 140 },
    { field: "date", headerName: "Start Date", flex: 1, minWidth: 100 },
    { field: "start", headerName: "Start", flex: 1, minWidth: 50 },
    { field: "carried", headerName: "Carried", flex: 1, minWidth: 70 },
    { field: "accrued", headerName: "Accrued", flex: 1, minWidth: 70, },
    { field: "sold", headerName: "Sold", flex: 1, minWidth: 50 },
    { field: "used", headerName: "Used", flex: 1, minWidth: 50 },
    { field: "planned", headerName: "Planned", flex: 1, minWidth: 70 },
    {
      field: "available",
      headerName: "Available",
      flex: 1,
      minWidth: 80,
      // valueGetter: (params) =>
      //   params.row.start != 0 ? params.row.start + 0 - params.row.used + 0 : "",
    },
  ];

  const columns2 = [
    {
      field: 'Shift_Date',
      headerName: 'Shift Date',
      width: 160,
      renderCell: (params) => {
        return moment(params.value).format('MM/DD/YYYY');
      },
    },
    {
      field: 'Shift_Code',
      headerName: 'Shift',
      width: 300,
      renderCell: (params) => {
        const status = params.value;
        return <Chip
          sx={{
            height: 'auto',
            '& .MuiChip-label': {
              display: 'block',
              whiteSpace: 'normal',
            },
          }}
          style={{
            textAlign: 'center',
            padding: '6px 0px',
            width: '60%',
            color: '#2E3238',
            backgroundColor: status === 2 ? 'rgba(255, 165, 0, 0.26)' : 'rgba(52, 152, 219, 0.16)',
            border: status === 2 ? '1px solid rgba(255, 165, 0, 0.28)' : '1px solid rgba(52, 152, 219, 0.2)'
          }}
					label={status === 2 ? 'Day' : status === 91 ? `${params?.row?.TempShiftType}` : 'Night'}
        />;
      },
    },
    { field: 'Request_By', headerName: 'Requested by', width: 220 },
    { field: 'Request_To', headerName: 'Requested to', width: 220 },
		{
      field: 'Cancel_swap',
      headerName: 'Status',
			width : 240,
      renderCell: (params) => {
        return (
					<Button
						variant="contained"
						sx={{
							backgroundColor: 
								(params.row.requestedCancelSwap && params.row.requestedCancelSwapStatus == 'Requested') ? 'orange' : 
								(params.row.requestedCancelSwapStatus == 'DECLINED' && params.row.requestedCancelSwap) ? '#000000' : '#ff0000',
							color: (params.row.requestedCancelSwap && params.row.requestedCancelSwapStatus == 'Requested')  ? '#000000'
								: (params.row.requestedCancelSwapStatus == 'DECLINED' && params.row.requestedCancelSwap) ? '#ffffff'
							 : '#ffffff',
							marginLeft:'10px',
							padding : '4px 20px',
							boxShadow:'none',
							borderRadius:'30px',
							width: '140px',
							'&:hover': {
								backgroundColor: 
								(params.row.requestedCancelSwap && params.row.requestedCancelSwapStatus == 'Requested') ? 'orange' : 
								(params.row.requestedCancelSwapStatus == 'DECLINED' && params.row.requestedCancelSwap) ? '#000000' : '#E62719',
								boxShadow:'none',
							},
						}}
					>	{params.row.requestedCancelSwap ? params.row.requestedCancelSwapStatus : 'Request Swap'}
					</Button>
				);
      },
    },
		
  ];

  useEffect(() => {
    setLoading(true)
    ApiService.get("/ot-swap-report/" + empId, {
      'year': selectedYear
    })
      .then(({ data }) => {
        setLoading(false);
				const objectData = data?.data || {};
				const arrayData = Object.values(objectData); 
				const updatedRows = arrayData.map((item, index) => ({
					...item,
					id: index + 1 
				}));
				
				setSwapRows(updatedRows);
      })
      .catch((error) => {
        setLoading(false);
        setSwapRows([]);
        if (error?.response?.status == 400 && error?.response?.data?.message) {
          setSwapErrorMessage(error?.response?.data?.message);
        } else {
          toast.error(error?.response?.data?.message)
          // enqueueSnackbar("Error", { variant: "error" });
          navigate("/firehouse/members");
        }
      });
  }, [year, selectedYear]);

  const columns3 = [
    {
      field: 'start_date',
      headerName: 'Date',
      width: 240,
      renderCell: (params) => {
        return `(${params.row.start_date}  to  ${params.row.end_date})`
      },
    },
    { field: 'name', headerName: 'Swaps with', width: 300 },
    {
      field: 'sent_count',
      headerName: 'Swaps Request',
      width: 210,
      renderCell: (params) => {
        return <p style={{ borderRadius: '20px', padding: '2px 8px', backgroundColor: '#ff0000', color: '#ffffff', marginTop: '18px' }}>
          {params.value}
        </p>
      },
    },
    {
      field: 'received_count',
      headerName: 'Swaps Done',
      width: 210,
      renderCell: (params) => {
        return <p style={{ borderRadius: '20px', padding: '2px 8px', backgroundColor: '#008000', color: '#ffffff', marginTop: '18px' }}>
          {params.value}
        </p>
      },
    },
    {
      field: 'swap_balance',
      headerName: 'Balances',
      width: 210,
      renderCell: (params) => {
        return <p style={{ borderRadius: '20px', padding: '2px 8px', backgroundColor: '#555555', color: '#ffffff', marginTop: '18px' }}>
          {params.value}
        </p>
      },
    },
  ];

  useEffect(() => {
    setLoading(true)
    ApiService.get("/ot-swap-balance-report/" + empId,
      {
        'year': selectedYear2
      }
    )
      .then((data) => {
        setLoading(false);
        const responseData = data?.data?.data;
        const updatedRows = [];
        Object.entries(responseData).forEach(([fromId, fromData]) => {
          const fromName = fromData.full_name;
          const swapWith = fromData.swap_with;
          const start_date = moment(fromData.start_date).format('MM/DD/YYYY');
          const end_date = moment(fromData.end_date).format('MM/DD/YYYY');

          Object.entries(swapWith).forEach(([toId, toData], index) => {
            updatedRows.push({
              id: index + 1,
              name: toData.full_name,
              start_date: start_date,
              end_date: end_date,
              sent_count: toData.sent_count,
              received_count: toData.received_count,
              swap_balance: toData.swap_balance,
            });
          });
        });
        setSwapBalanceRows(updatedRows)
      })
      .catch((error) => {
        setLoading(false);
        toast.error(error?.response?.data?.message)
        // enqueueSnackbar("Error", { variant: "error" });
      });
  }, [year2, selectedYear2]);

  const detailsRes = useMemo(() => {
    // console.log('memo',row.employees);
    // console.log('memo',row.employees.filter(x => x.employee.fullName === searchText));
    return data?.details.filter((x) => {
      return (
        x.AbsentDesc.toLowerCase().includes(detailsSearch.toLowerCase()) ||
        x.Overtime_List.toLowerCase().includes(detailsSearch.toLowerCase())
      );
    });
  }, [detailsSearch, data]);
  const overtimeRes = useMemo(() => {
    // console.log('memo',row.employees);
    // console.log('memo',row.employees.filter(x => x.employee.fullName === searchText));
    return data?.overTime.filter((x) => {
      return (
        x.ResponseName.toLowerCase().includes(overTimeSearch.toLowerCase()) ||
        x.Shift_Type.toLowerCase().includes(overTimeSearch.toLowerCase()) ||
        x.fullName.toLowerCase().includes(overTimeSearch.toLowerCase())
      );
    });
  }, [overTimeSearch, data]);
  const summaryRes = useMemo(() => {
    // console.log('memo',row.employees);
    // console.log('memo',row.employees.filter(x => x.employee.fullName === searchText));
    return data?.summary.filter((x) => {
      return (
        x.name.toLowerCase().includes(summarySearch.toLowerCase()) ||
        x.start.toString().includes(summarySearch.toLowerCase())
      );
    });
  }, [summarySearch, data]);


  if (loading) {
    return (
      <Box className="w-100 d-flex justify-content-center align-items-center" style={{height: 665}}>
        <CircularProgress />
      </Box>
    );
  } else {
    return (
      <>
        <Box className='m-3'>
          <Link to="/firehouse/members" style={{ color: "#555555" }}>
            <ArrowBackIosIcon />
          </Link>
          <span className="fw-500">Member ({member.fullName})</span>
        </Box>
        <Paper className="m-3">
          <Box className='px-3' style={{ paddingTop: activeTab == 'memberlog' ? '35px' : '26px' }}>
            <Row>
              <Col md={8} sm={10} xs={10} style={{ display: 'flex', alignItems: 'center' }}>
                <div style={{ width: '160px' }} className={activeTab == 'memberlog' ? 'tab-active' : 'tab-white'}
                  onClick={() => setActiveTab('memberlog')}>
                  Member Log
                </div>
                <div style={{ width: '160px' }} className={activeTab == 'swaps-list' ? 'tab-active mx-2' : 'tab-white mx-2'}
                  onClick={() => setActiveTab('swaps-list')}>
                  Swap Details
                </div>
                <div style={{ width: '160px' }} className={activeTab == 'swaps-balances' ? 'tab-active' : 'tab-white'}
                  onClick={() => setActiveTab('swaps-balances')}>
                  Swap Balances
                </div>
              </Col>
              {(activeTab == 'swaps-list') &&
                <Col md={4} sm={10} xs={10}>
                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <Grid container spacing={3}>
                      <Grid item md={6} sm={10} xs={10}>
                        <DatePicker
                          label="Select Year"
                          views={['year']}
                          value={year}
                          onChange={(newValue) => setYear(newValue)}
                          renderInput={(params) => <TextField {...params} />}
                        />
                      </Grid>
                    </Grid>
                  </LocalizationProvider>
                </Col>
              }
              {(activeTab == 'swaps-balances') &&
                <Col md={4} sm={10} xs={10}>
                  <Row>
                    <Col md={6} sm={10} xs={10}>
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DatePicker
                          label="Select Year"
                          views={['year']}
                          value={year2}
                          onChange={(newValue) => setYear2(newValue)}
                          renderInput={(params) => <TextField {...params} />}
                        />
                      </LocalizationProvider>
                    </Col>
                  </Row>
                </Col>
              }
            </Row>
          </Box>

          {activeTab == 'memberlog' &&
            <div>
              {data && (
                <>
                  <Box className="p-4 my-3" sx={{ maxWidth: '93vw' }}>
                    <div className="container m-0 p-0">
                      <p className="fw-500 h4">
                        {data &&
                          data.employee.employee_assignment?.EA_Rank +
                          " " +
                          data.employee.fullName}
                      </p>
                      <p className="fw-500 fs-5">
                        Time Off & Accruals (current period).
                      </p>


                      <Box sx={{ flexGrow: 1 }} >
                        <Grid container spacing={2}>
                          <Grid item xs={12} sm={12} md={6}>
                            <Box sx={{
                              height: '50vh !important',
                              contain: 'content',
                              border: '1px solid #cccccc !important',
                              borderRadius: '8px',
                              padding: '10px',
                              // overflowY: 'scroll',
                              '@media (max-width: 600px)': {
                                height: 'fit-content !important',
                              },
                            }}
                            >
                              <p className="fw-600 fs-18 mt-1">
                                Details
                              </p>
                              <MyTable
                                rows={detailsRes}
                                columns={columns}
                                checkboxSelection={false}
                                useTopFilter={true}
                                hideFooter={true}
                                useSearch={(e) => setDatailsSearch(e)}
                              />
                            </Box>
                          </Grid>
                          <Grid item xs={12} sm={12} md={6}>
                            <Box sx={{
                              height: '50vh !important',
                              contain: 'content',
                              border: '1px solid #cccccc !important',
                              padding: '10px',
                              borderRadius: '8px',
                              // overflowY: 'scroll',
                              '@media (max-width: 600px)': {
                                height: 'fit-content !important',
                              },
                            }}>
                              <p className="fw-600 fs-18 mt-1">
                                Summary
                              </p>
                              <MyTable
                                rows={summaryRes}
                                columns={columnsSummary}
                                checkboxSelection={false}
                                useTopFilter={true}
                                hideFooter={true}
                                useSearch={(e) => setSummarySearch(e)}
                                sx={{
                                  height: '100%',
                                  overflow: 'auto',
                                }}
                              />
                            </Box>
                          </Grid>
                        </Grid>
                      </Box>

                      <Box>
                        <p className="fw-600 fs-18 mt-5">
                          Overtime Lists
                        </p>
                        <MyTable
                          rows={overtimeRes}
                          columns={columnsOverTime}
                          checkboxSelection={false}
                          useTopFilter={true}
                          hideFooter={true}
                          useSearch={(e) => setOverTimeSearch(e)}
                        />
                      </Box>
                    </div>
                  </Box>
                </>
              )}
              {emptyMessage && (
                <>
                  <div className='d-flex flex-column align-items-center justify-content-center' style={{ height: 565, width: "100%" }}>
                              <img src='/images/blur-logo.png' style={{ height: 200, width: 250 }} />
                              <span className='mt-4' style={{ color: '#555555' }}>
                               {emptyMessage}
                              </span>
                            </div>
                </>
              )}
            </div>
          }

          {loading &&
            <Box className="w-100 d-flex justify-content-center align-items-center" style={{height: 665}}>
              <CircularProgress />
            </Box>
          }

          {activeTab == 'swaps-list' &&
            <div>
              {swapRows.length > 0 ? (
                <Box className='p-3'>
                  <MyTable
                    rows={swapRows}
                    columns={columns2}
                    checkboxSelection={false}
                    useTopFilter={false}
                  />
                </Box>
              ) : (
                 <div className='d-flex flex-column align-items-center justify-content-center' style={{ height: 565, width: "100%" }}>
                              <img src='/images/blur-logo.png' style={{ height: 200, width: 250 }} />
                              <span className='mt-4' style={{ color: '#555555' }}>
                                No Details Found
                              </span>
                            </div>
              )}
            </div>
          }

          {activeTab == 'swaps-balances' &&
            <div>
              {swapBalanceRows.length > 0 ? (
                <Box className='p-3'>
                  <MyTable
                    rows={swapBalanceRows}
                    columns={columns3}
                    checkboxSelection={false}
                    useTopFilter={false}
                  />
                </Box>
              ) : (
                   <div className='d-flex flex-column align-items-center justify-content-center' style={{ height: 565, width: "100%" }}>
                              <img src='/images/blur-logo.png' style={{ height: 200, width: 250 }} />
                              <span className='mt-4' style={{ color: '#555555' }}>
                                No Balances Found
                              </span>
                            </div>
              )}
            </div>
          }
        </Paper>
      </>
    );
  }
}
